<script setup lang="ts">
import type { CoachOption } from "./types.ts";

withDefaults(
  defineProps<{
    advisor: CoachOption;
    conflict?: boolean;
  }>(),
  { conflict: false },
);

const emit = defineEmits<{
  (e: "remove"): void;
  (e: "update:ordinal", value: number | undefined): void;
}>();

const onOrdinalInput = (event: Event): void => {
  const value = (event.target as HTMLInputElement).value;
  emit("update:ordinal", value ? Number(value) : undefined);
};
</script>

<template>
  <div class="flex w-full items-center gap-2">
    <span class="drag-handle material-symbols-outlined shrink-0 cursor-grab select-none text-base text-gray-500">drag_indicator</span>
    <div
      class="flex flex-1 min-w-0 items-center gap-1.5 rounded px-2.5 py-1 text-sm text-indigo-base"
      :class="conflict ? 'border border-red-300 bg-red-light' : 'bg-gray-200'"
    >
      <span class="flex-1 min-w-0 whitespace-nowrap">{{ advisor.displayName }}</span>
      <button
        type="button"
        class="flex shrink-0 items-center text-gray-600 hover:text-gray-700"
        :aria-label="`Remove ${advisor.displayName}`"
        @click="emit('remove')"
      >
        <span class="material-symbols-outlined text-sm">close</span>
      </button>
    </div>
    <div class="flex shrink-0 items-center gap-1.5">
      <span class="flex flex-col text-xs leading-tight text-gray-600">
        <span>Contact</span>
        <span>Order</span>
      </span>
      <input
        type="number"
        min="1"
        :value="advisor.ordinal ?? ''"
        class="h-[30px] w-[52px] shrink-0 rounded border px-1.5 text-center text-sm font-medium outline-none focus:ring-2"
        :class="
          conflict
            ? 'border-red-500 bg-red-light text-red-700 focus:border-red-500 focus:ring-red-500/15'
            : 'border-gray-400 bg-white text-indigo-base focus:border-teal-900 focus:ring-teal-900/15'
        "
        :aria-label="`Contact order for ${advisor.displayName}`"
        @input="onOrdinalInput"
      />
    </div>
  </div>
</template>
